import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function ViolationsIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 30, 30);
  const a11y = resolveA11yProps(props);

  return (
    <svg
      viewBox="0 0 30 30"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      width={width}
      height={height}
      {...rest}
      {...a11y}
    >
      {title ? <title>{title}</title> : null}
      <path
        d="M15 11.6984V17.2527M15 22.807H15.0136M13.1112 4.60524L1.89191 24.3321C1.26961 25.4263 0.958467 25.9734 1.00445 26.4224C1.04456 26.8141 1.24613 27.1699 1.55899 27.4015C1.91768 27.667 2.53869 27.667 3.78071 27.667H26.2193C27.4613 27.667 28.0823 27.667 28.441 27.4015C28.7539 27.1699 28.9554 26.8141 28.9955 26.4224C29.0415 25.9734 28.7304 25.4263 28.1081 24.3321L16.8888 4.60524C16.2687 3.51498 15.9587 2.96986 15.5542 2.78677C15.2014 2.62707 14.7986 2.62707 14.4458 2.78677C14.0413 2.96986 13.7313 3.51499 13.1112 4.60524Z"
        stroke="#D15B46"
        strokeWidth={1.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 11.6992V17.2535M15 22.8078H15.0136"
        stroke="#D15B46"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default ViolationsIcon;
